export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false
};
export const PageName = '创建助力共富81活动推荐奖励配置';